/**
 * Created by Daniel Wang on 06/09/2022.
 * Description:
 * Effects for handling general page of admin console
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { AdminPageActionTypes } from '../../actions/admin-page.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { AdminPagesService } from '../../../tamalelibs/services/admin-page.service';

@Injectable()
export class AdminPageGeneralEffects {
    constructor(
        private _actions$: Actions,
        private _adminPageService: AdminPagesService
    ) { }

    updateDefaultSidenoteTypeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.UPDATE_DEFAULT_SIDENOTE_TYPE),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._adminPageService.updateGeneralInfo(payload)
            .pipe(
                map(response => ({
                    type: AdminPageActionTypes.UPDATE_DEFAULT_SIDENOTE_TYPE_SUCCESS,
                    payload: response
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.UPDATE_DEFAULT_SIDENOTE_TYPE_FAILED,
                        payload: err.message
                    });
                })
            )
        )
    ));
}
